import get from "lodash/get"

import authentication from "./authentication"
import users from "./users"
import imported from "./imported"
import prerequisites from "./prerequisites"

const DEFAULT_MAP = (_, result, originalPayload) => ({
    result,
    originalPayload,
})

const mappers = {
    ...authentication,
    ...users,
    ...imported,
    ...prerequisites,
}

export const getMap = type => {
    const map = get(mappers, type, DEFAULT_MAP)

    return map
}

export default mappers
